import {Middleware} from '@reduxjs/toolkit'

import {saveStateToStorage} from '@web/actions/restoreState'
import getStorage from '@web/helpers/storage'

import {SessionSyncCreatorProps} from './interfaces'

const saveStorage = <S extends string | object>(key: string, state: S) => {
    const storage = getStorage<S>(key)
    storage.set(state)
}

/**
 * T Generic에는 반환할 미들웨어 내부에서 참조(getState)할 Store의 Type
 * S Generic에는 storage에 저장할 data의 Type
 */
const sessionSyncCreator =
    <S>({
        actionWithSessions,
        createSessionKey,
        createKey,
        createExtraKeys,
        type = 'saveState',
    }: SessionSyncCreatorProps<S>): Middleware<object, S> =>
    ({getState}) =>
    (next) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action: any) => {
        next(action)

        if (actionWithSessions.includes(action.type)) {
            const state = getState()
            const id = createSessionKey(state)
            const key = createKey ? createKey(state) : createSessionKey(state)
            const extraKeys = createExtraKeys?.(state)
            type === 'saveState'
                ? saveStateToStorage<S>({
                      secureStorageKey: id,
                      saverKey: key,
                      currentState: {
                          ...state,
                          ...extraKeys,
                      },
                  })
                : saveStorage(id, {...state, ...extraKeys})
        }
    }

export default sessionSyncCreator
